import React from 'react';
import { useSelector } from 'react-redux';
import { Form } from 'ui/components';

import { DatePicker, Select } from 'ui/components';

import { formatDate } from 'utilities/common';

export const ShippingDetails = ({ onValueChange, method, errors }) => {
  const Session = useSelector((state) => state?.Auth?.session);

  const [vendor, setVendor] = React.useState(null);
  const [schedule, setSchedule] = React.useState({
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  });
  const [origin, setOrigin] = React.useState(null);
  const [cost, setCost] = React.useState(0);

  React.useEffect(() => {
    const value = {
      vendor,
      schedule,
      origin,
      total_cost: cost,
    };
    onValueChange(value);
  }, [vendor, schedule, origin, cost]);

  React.useEffect(() => {
    if (!Session?.hub) return;
    setOrigin(Session?.hub);
  }, [Session]);

  return (
    <div className="row">
      <div className="col-md-6">
        <Select.Remote
          required={method === 'external'}
          label="Pilih Vendor"
          placeholder=""
          url="/partner"
          params={{'type': 'vendor'}}
          initialValue={vendor?.id}
          value={vendor}
          row={(d) => {
            return {
              value: d.id,
              label: d.name,
            };
          }}
          onSelected={(c) => {
            setVendor(c);
          }}
          errors={errors?.vendor}
        />
      </div>

      {!Session?.hub && (
        <div className="col-md-6">
          <div className="mb-3">
            <Select.Remote
              label="Pilih Origin"
              required
              isSearch={false}
              placeholder=""
              url="/location/hub"
              params={{ type: 'hub', is_active: 1 }}
              row={(d) => {
                return { value: d.id, label: d.name };
              }}
              onSelected={(e) => setOrigin(e)}
              errors={errors?.origin}
            />
          </div>
        </div>
      )}

      <div className="col-md-6">
        <label className="form-label required">Pilih Jadwal</label>
        <div className={errors?.schedule ? 'border border-danger rounded' : ''}>
          <DatePicker
            type="normal"
            value={schedule?.default}
            format="dd/MM/yyyy"
            onChange={(date) => {
              setSchedule({
                default: date,
                formatted: formatDate(date, 'YYYY-MM-DD'),
              });
            }}
            isShowTrigger
            error={errors?.schedule}
          />
        </div>

        {errors?.schedule ? (
          <div className="invalid-feedback" style={{ display: 'block' }}>
            {errors?.schedule}
          </div>
        ) : null}
      </div>

      <div className="col-md-6">
        <Form.Input
          value={cost}
          onChange={(e) => setCost(e.target.valueNumber)}
          type="number"
          label="Harga Pengiriman"
          error={errors?.total_cost}
        />
      </div>
    </div>
  );
};
